<template>
  <div class="page-content-wrapper" v-check-permission="'edit-careers'">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="card m-b-20">
            <div class="card-block">

              <h4 class="mt-0 header-title">Carrera</h4>
              <template v-if="career">
                <div class="form-group" v-bind:class="{ 'has-danger': $v.career.name.$error }">
                  <label>Nombre</label>
                  <input type="text" class="form-control col-md-6" v-model="career.name" @input="$v.career.name.$touch()">
                  <div class="form-control-feedback" v-if="!$v.career.name.required && $v.career.name.$error">El nombre es requerido.</div>
                </div>
                <div class="form-group  m-b-0">
                  <label>Estado</label>
                  <div>
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" v-model="career.active">
                      <span class="custom-control-indicator"></span>
                      <span class="custom-control-description">Activo</span>
                    </label>
                  </div>
                </div>


                <div v-if="career && career._id" class="table-responsive b-0 mt-5" data-pattern="priority-columns">

                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th>Planes de estudio</th>
                      <th>Estado</th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr v-for="_studyPlan in career.studyPlans" :key="_studyPlan._id">
                        <td>{{ _studyPlan.resolution }}</td>
                        <td>
                          <span class="badge badge-success" v-if="_studyPlan.active">Activo</span>
                          <span class="badge badge-primary" v-if="!_studyPlan.active">Inactivo</span>
                          <span class="badge badge-success" v-if="_studyPlan.isDefault">Predeterminado</span>
                        </td>
                        <td class="pull-right">
                          <a href="javascript:void(0);" class="text-info mr-3" @click="editStudyPlan(_studyPlan._id)"><i class="fa fa-pencil"></i></a>
                          <a href="javascript:void(0);" class="text-primary" @click="deleteStudyPlan(_studyPlan._id)"><i class="fa fa-minus-circle"></i></a>
                        </td>
                      </tr>
                      <tr v-if="career.studyPlans && career.studyPlans.length === 0">
                        <td colspan="3">Aun no se ha cargado planes de estudio.</td>
                      </tr>
                    </tbody>
                  </table>

                  <div class="mb-3 col-md-12 d-inline-block">
                    <button class="btn btn-info pull-right btn-add-new-study-plan" @click="showAddStudyPlanForm()">Agregar plan de estudio</button>
                  </div>




                  <div class="card card-body add-new-study-plan" style="background-color: #f5f6f9; border-color: #f5f6f9;">
                    <div class="card-block">
                      <h4 class="mt-0 header-title">Plan de estudios</h4>

                      <div class="form-group row">
                        <div class="col-md-6" v-bind:class="{ 'has-danger': $v.studyPlan.resolution.$error }">
                          <label>Numero de resolución</label>
                          <input type="text" class="form-control" v-model="studyPlan.resolution" @input="$v.studyPlan.resolution.$touch()">
                          <div class="form-control-feedback" v-if="!$v.studyPlan.resolution.required && $v.studyPlan.resolution.$error">El numero de resolución es requerido.</div>
                        </div>
                        <div class="col-md-6">
                          <label>Numero de expediente</label>
                          <input type="text" class="form-control" v-model="studyPlan.fileNumber">
                        </div>
                      </div>
                      <div class="form-group">
                        <label>Contenido de la resolución</label>
                        <textarea type="text" class="form-control col-md-12" v-model="studyPlan.content" ></textarea>
                      </div>
                      <div class="form-group  m-b-0">
                        <label>Estado</label>
                        <div>
                          <label class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" v-model="studyPlan.active">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description">Activo</span>
                          </label>
                        </div>
                        <div>
                          <label class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" v-model="studyPlan.isDefault">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description">Predeterminado</span>
                          </label>
                        </div>
                      </div>

                      <table class="table table-striped">
                        <thead>
                        <tr>
                          <th>Años</th>
                          <th>Materias</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="_level in studyPlan.levels" :key="_level._id">
                          <td>{{ _level.value}} - {{ _level.name }}</td>
                          <td>
                            <span class="badge badge-success" v-if="_level">{{_level.subjects.length}}</span>
                          </td>
                          <td class="pull-right">
                            <a class="text-info mr-3" @click="editLevel(_level._id)"><i class="fa fa-pencil"></i></a>
                            <a href="javascript:void(0);" class="text-primary" @click="deleteLevel(_level._id)"><i class="fa fa-minus-circle"></i></a>
                          </td>
                        </tr>
                        <tr v-if="studyPlan.levels && studyPlan.levels.length === 0">
                          <td colspan="3">Aun no se han agregado años al plan de estudios.</td>
                        </tr>
                        </tbody>
                      </table>

                      <div class="mb-3 col-md-12 d-inline-block">
                        <button class="btn btn-info pull-right btn-add-new-level" @click="showAddNewLevelForm()">Agregar año</button>
                      </div>





                      <div class="card card-body add-new-level" style="background-color: #ffffff; border-color: #ffffff;">
                        <div class="card-block">
                          <h4 class="mt-0 header-title">Año</h4>

                          <div class="form-group row">
                            <div class="col-md-3" v-bind:class="{ 'has-danger': $v.level.value.$error }">
                              <label>Nivel</label>
                              <input type="number" class="form-control" v-model="level.value" @input="$v.level.value.$touch()">
                              <small>(Ingresar el valor numérico. Por ejemplo: <b>1</b>)</small>
                              <div class="form-control-feedback" v-if="!$v.level.value.required && $v.level.value.$error">El numero de resolución es requerido.</div>
                            </div>
                            <div class="col-md-9">
                              <label>Nombre / Descripción</label>
                              <input type="text" class="form-control" v-model="level.name">
                              <small>(Ingresar la descripción del valor numerico. Por ejemplo: <b>Primero</b>)</small>
                            </div>
                          </div>
                          <table class="table table-striped">
                            <thead>
                            <tr>
                              <th>Materias</th>
                              <th>Horas semanales</th>
                              <th>Duración</th>
                              <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="_subject in level.subjects" :key="_subject._id">
                              <td>{{ _subject.curricularSpace }}</td>
                              <td>{{ _subject.weeklyHours }}</td>
                              <td>{{ getSubjectDuration(_subject.duration) }}</td>
                              <td class="pull-right">
                                <a href="javascript:void(0);" class="text-info mr-3" @click="editSubject(_subject._id)"><i class="fa fa-pencil"></i></a>
                                <a href="javascript:void(0);" class="text-primary" @click="deleteSubject(_subject._id)"><i class="fa fa-minus-circle"></i></a>
                              </td>
                            </tr>
                            <tr v-if="level.subjects && level.subjects.length === 0">
                              <td colspan="4">Aun no se han agregado materias.</td>
                            </tr>
                            </tbody>
                          </table>

                          <div class="mb-3 col-md-12 d-inline-block">
                            <button class="btn btn-info pull-right btn-add-new-subject" @click="showAddNewSubjectForm()">Agregar materia</button>
                          </div>






                          <div class="card card-body add-new-subject" style="background-color: #f5f6f9; border-color: #f5f6f9;">
                            <div class="card-block">
                              <h4 class="mt-0 header-title">Materia</h4>

                              <div class="form-group row">
                                <div class="col-md-4" v-bind:class="{ 'has-danger': $v.subject.curricularSpace.$error }">
                                  <label>Espacio curricular</label>
                                  <input type="text" class="form-control" v-model="subject.curricularSpace" @input="$v.subject.curricularSpace.$touch()">
                                  <div class="form-control-feedback" v-if="!$v.subject.curricularSpace.required && $v.subject.curricularSpace.$error">El espacio curricular es requerido.</div>
                                </div>

                                <div class="col-md-4">
                                  <label>Horas semanales</label>
                                  <input type="number" class="form-control" v-model="subject.weeklyHours">
                                </div>

                                <div class="col-md-4">
                                  <label>Duración</label>
                                  <select id="subjectDuration" class="custom-select form-control d-block w-100" v-model="subject.duration">
                                    <option v-for="duration in subjectDuration" :value="duration.value">
                                      {{ duration.text }}
                                    </option>
                                  </select>
                                </div>
                              </div>

                            </div>

                            <div class="card-block d-inline-block col-md-12">
                              <a href="javascript:void(0);" class="btn btn-primary waves-effect waves-light save-btn pull-right m-r-10" @click="addSubject()">Agregar materia</a>
                              <a href="javascript:void(0);" class="btn btn-secondary waves-effect m-r-10 pull-right" @click="hideAddNewSubjectForm()">Cancelar</a>
                            </div>
                          </div>

                        </div>

                        <div class="card-block d-inline-block col-md-12">
                          <a href="javascript:void(0);" class="btn btn-primary waves-effect waves-light save-btn pull-right m-r-10" @click="addLevel()">Agregar año</a>
                          <a href="javascript:void(0);" class="btn btn-secondary waves-effect pull-right m-r-10" @click="hideAddNewLevelForm()">Cancelar</a>
                        </div>
                      </div>

                    </div>

                    <div class="card-block d-inline-block col-md-12">
                      <a href="javascript:void(0);" class="btn btn-primary waves-effect waves-light save-btn pull-right m-r-10" @click="addStudyPlan()">Agregar plan de estudios</a>
                      <a href="javascript:void(0);" class="btn btn-secondary waves-effect  pull-right m-r-10" @click="hideAddStudyPlanForm()">Cancelar</a>
                    </div>
                  </div>
                </div>

                <div v-else>
                  <small>Después de que guardes la carrera se habilitará la opción de agregar planes de estudio.</small>
                </div>


                <div class="card-block pull-right pr-0">
                  <router-link to="/careers" class="btn btn-secondary waves-effect m-r-10">Cancelar</router-link>
                  <a href="javascript:void(0);" class="btn btn-primary waves-effect waves-light save-btn" @click="submit()">Guardar</a>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'
  import subjectDuration from '../data/subjectDuration'

  export default {
    name: 'edit-career',

    created () {
      this.getCareer()
    },

    data () {
      return {
        studyPlan: {
          _id: null,
          resolution: '',
          active: false,
          content: '',
          resolutionDate: '',
          fileNumber: '',
          isDefault: false,
          levels: []
        },
        subjectDuration: subjectDuration,
        subject: {
          _id: null,
          curricularSpace: '',
          duration: '',
          weeklyHours: ''
        },
        level: {
          _id: null,
          name: '',
          value: null,
          subjects: []
        }
      }
    },

    computed: {
      career: function () {
        return this.$store.getters.getCareer
      }
    },

    validations: {
      career: {
        name: {
          required
        }
      },
      studyPlan: {
        resolution: {
          required
        }
      },
      level: {
        value: {
          required
        }
      },
      subject: {
        curricularSpace: {
          required
        }
      },
    },

    methods: {

      submit: function () {

        const self = this;
        this.$v.career.$touch();

        if(!this.$v.career.$error) {

          $('.save-btn').attr('disabled', true)

          this.$store.dispatch('editCareer', { career: this.career })
            .then((response) => {

              if(response.success) {
                self.$message.success();

                /*setTimeout(function () {
                  self.$router.push('/careers')
                }, 500)*/

              } else {

                self.$message.error({text: response.message});

              }

              $('.save-btn').attr('disabled', false)
            })
            .catch((response) => {
              self.$message.error({text: response.message});
              $('.save-btn').attr('disabled', false)
            })
        }
      },

      getCareer: function () {

        this.$loader.loading();

        this.$store.dispatch('getCareer', { id : this.$route.params.id })
          .then((response) => {
            this.$loader.close();
          })
          .catch(error => {
            this.$message.error({ text: error });
            this.$loader.close();
          })
      },

      showAddStudyPlanForm: function () {
        this.clearStudyPlan();
        $('.add-new-study-plan').css('display', 'block');
        $('.btn-add-new-study-plan').css('display', 'none');
      },

      showEditStudyPlanForm: function () {
        $('.add-new-study-plan').css('display', 'block');
        $('.btn-add-new-study-plan').css('display', 'none');
      },

      hideAddStudyPlanForm: function () {
        $('.add-new-study-plan').css('display', 'none');
        $('.btn-add-new-study-plan').css('display', 'block');
      },

      showAddNewLevelForm: function () {
        this.clearLevel();
        $('.add-new-level').css('display', 'block');
        $('.btn-add-new-level').css('display', 'none');
      },

      showEditLevelForm: function () {
        $('.add-new-level').css('display', 'block');
        $('.btn-add-new-level').css('display', 'none');
      },

      hideAddNewLevelForm: function () {
        $('.add-new-level').css('display', 'none');
        $('.btn-add-new-level').css('display', 'block');
      },

      showAddNewSubjectForm: function () {
        this.clearSubject();
        $('.add-new-subject').css('display', 'block');
        $('.btn-add-new-subject').css('display', 'none');
      },

      showEditSubjectForm: function () {
        $('.add-new-subject').css('display', 'block');
        $('.btn-add-new-subject').css('display', 'none');
      },

      hideAddNewSubjectForm: function () {
        $('.add-new-subject').css('display', 'none');
        $('.btn-add-new-subject').css('display', 'block');
      },

      addStudyPlan: function () {
        if(!this.studyPlan._id) {
          this.studyPlan._id = this.$uid.generateUID();
          this.career.studyPlans.push(this.studyPlan);
        }
        this.hideAddStudyPlanForm();
      },

      clearStudyPlan: function () {
        this.studyPlan = {
          _id: null,
          resolution: '',
          active: false,
          content: '',
          resolutionDate: '',
          fileNumber: '',
          isDefault: false,
          levels: []
        }
      },

      deleteStudyPlan(id) {
        this.career.studyPlans = this.career.studyPlans.filter(function (item) {
          return id != item._id;
        });
        this.hideAddStudyPlanForm();
      },

      editStudyPlan(id) {
        this.studyPlan = this.career.studyPlans.filter(function (item) {
          return id === item._id;
        })[0];
        this.showEditStudyPlanForm();
      },

      addLevel: function () {
        if(!this.level._id) {
          this.level._id = this.$uid.generateUID();
          this.studyPlan.levels.push(this.level);
        }
        this.hideAddNewLevelForm();
      },

      deleteLevel(id) {
        this.studyPlan.levels = this.studyPlan.levels.filter(function (item) {
          return id != item._id;
        })
      },

      editLevel(id) {
        this.level = this.studyPlan.levels.filter(function (item) {
          return id === item._id;
        })[0];
        this.showEditLevelForm();
      },

      clearLevel: function () {
        this.level = {
          _id: null,
          name: '',
          value: null,
          subjects: []
        }
      },

      addSubject: function () {
        if(!this.subject._id) {
          this.subject._id = this.$uid.generateUID();
          this.level.subjects.push(this.subject);
        }
        this.hideAddNewSubjectForm();
      },

      deleteSubject(id) {
        this.level.subjects = this.level.subjects.filter(function (item) {
          return id != item._id;
        })
      },

      editSubject(id) {
        this.subject = this.level.subjects.filter(function (item) {
          return id === item._id;
        })[0];
        this.showEditSubjectForm();
      },

      clearSubject: function () {
        this.subject = {
          _id: null,
          curricularSpace: '',
          duration: '',
          weeklyHours: ''
        }
      },

      getSubjectDuration: function (key) {
        var subjectDuration = this.subjectDuration.filter(function (item) {
          return key === item.value;
        });
        if(subjectDuration && subjectDuration.length > 0) {
          return subjectDuration[0].text;
        }
        return '--';
      }

    }
  }
</script>

<style scoped>
  .add-new-subject,
  .add-new-level,
  .add-new-study-plan {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/screens/EditCareerScreen.vue